import { IWheatData } from '@/modules/search/ts/index.types';
import { IStore } from '../hooks';
import { IAgricultureParameter } from '@/modules/agriculture/ts';

export function validateModal(
  modalState: { wheatData: IWheatData; stores: IStore[] },
  wheatForValidation: {
    gluten: IAgricultureParameter;
    humidity: IAgricultureParameter;
    idk: IAgricultureParameter;
    cp: IAgricultureParameter;
    protein: IAgricultureParameter;
    nature: IAgricultureParameter;
  },
) {
  const ranges = wheatForValidation;
  const checkedStores = modalState.stores.filter((item) => item.checked);
  const {
    wheatData: { params, sort, type, divergence },
  } = modalState;
  const result: IResult = {
    errors: [],
    warnings: [],
    success: true,
  };
  const errors = [];
  if (!sort || !type) result.warnings.push({ label: 'Не выбран сорт/тип пшеницы' });

  if (!params.cp) errors.push('число падения');
  if (!params.gluten) errors.push('клейковина');
  if (!params.humidity) errors.push('влажность');
  if (!params.idk) errors.push('ИДК');
  if (!params.nature) errors.push('натура');
  if (!divergence && divergence !== 0) errors.push('допустимое отклонение');
  if (!params.protein) errors.push('протеин');
  // if (!modalState.temperature) result.errors.push('температура');

  result.errors = errors;

  if (!checkedStores || checkedStores.length === 0)
    result.warnings.push({ label: 'Не выбраны склады для поиска!' });

  if (+divergence > 5)
    result.warnings.push({
      label:
        'Значение поля Допустимое отклонение от заданных параметров не может быть больше 5%',
    });
  if (!sort || !type) result.warnings.push({ label: 'Не выбран сорт/тип пшеницы' });
  if (!checkedStores || checkedStores.length === 0)
    result.warnings.push({ label: 'Не выбраны склады для поиска!' });

  // GLUTEN
  if (
    !isWithinRange(
      ranges.gluten.options as { min: number; max: number },
      params.gluten as unknown as number,
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.gluten),
    });
  }

  // HUMIDITY
  if (
    !isWithinRange(
      ranges.humidity.options as { min: number; max: number },
      params.humidity as unknown as number,
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.humidity),
    });
  }

  // CP
  if (
    !isWithinRange(
      ranges.cp.options as { min: number; max: number },
      params.cp as unknown as number,
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.cp),
    });
  }

  // NATURE
  if (
    !isWithinRange(
      ranges.nature.options as { min: number; max: number },
      params.nature as unknown as number,
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.nature),
    });
  }

  // PROTEIN
  if (
    !isWithinRange(
      ranges.protein.options as { min: number; max: number },
      params.protein as unknown as number,
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.protein),
    });
  }

  // IDK
  if (
    !isWithinRange(
      ranges.idk.options as { min: number; max: number },
      params.idk as unknown as number,
    )
  ) {
    result.warnings.push({
      label: generateWarningString(ranges.idk),
    });
  }

  result.success = !(result.errors.length || result.warnings.length);
  return result;
}

interface IResult {
  errors: string[];
  warnings: { label: string }[];
  success: boolean;
}

function isWithinRange(range: { min: number; max: number }, value: number): boolean {
  const valueParsed = parseFloat(String(value));
  return valueParsed >= range.min && valueParsed <= range.max;
}

function generateWarningString(wheatParam: IAgricultureParameter) {
  return `Допустимый диапазон для параметра '${wheatParam.name}' ${wheatParam.options.min}-${wheatParam.options.max}. Введите корректное значение.`;
}
